<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/master-pembelian/supplier"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Tambah Pembelian Supplier
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="12">
                          <ValidationProvider 
                            name="Nama Supplier" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Nama Supplier
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. John Doe"

                              hide-details

                              v-model="form.name"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <!-- <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Nomor Induk Pegawai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Nomor Induk Pegawai
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Contoh. 3102XXX"
                              
                              hide-details

                              v-model="form.nip"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.nip !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col> -->
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Email" 
                            rules="required|email" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Email
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. XXXX@gmail.com"

                              hide-details

                              v-model="form.email"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.email !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Mobilephone" 
                            rules="required|min:10|max:13" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Mobilephone
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"

                              :color="set_color"
                              placeholder="Contoh. 081XXXXXXXXX"

                              hide-details

                              v-model="form.mobilephone"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.mobilephone !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12">
                          <div class="fs-14 mb-1 black_two">
                            Nama PIC
                          </div>
                          <ValidationProvider 
                            name="Nama PIC" 
                            rules="required" 
                            v-slot="{ errors }">
                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. John Doe"

                              hide-details

                              v-model="form.pic_name"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.pic_name !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Email PIC" 
                            rules="required|email" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Email PIC
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. XXXX@gmail.com"

                              hide-details

                              v-model="form.pic_email"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.email !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Mobilephone PIC" 
                            rules="required|min:10|max:13" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Mobilephone PIC
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"

                              :color="set_color"
                              placeholder="Contoh. 081XXXXXXXXX"

                              hide-details

                              v-model="form.pic_mobilephone"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.mobilephone !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <div class="fs-14 mb-1 black_two">
                            Alamat Supplier
                            <span class="red--text">*</span>
                          </div>
                          <ValidationProvider 
                            name="Alamat Supplier" 
                            rules="required" 
                            v-slot="{ errors }">
                            <v-textarea
                              v-on:keyup.enter="save"
                              class="no_box"
                              outlined
                              dense
                              :color="set_color"
                              style="border-radius: 4px;"
                              placeholder="Masukkan alamat"
    
                              vv-uppercase
                              hide-details
    
                              v-model="form.address"
                              :error-messages="errors"
                              required>
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>


                      <v-row>
                        <v-col
                          cols="12"
                          class="py-0">
                          <label>
                            AutoComplete
                            <gmap-autocomplete
                              placeholder="ketik alamat"
                              class="mb-3 mt-2"
                              @place_changed="setPlace">
                            </gmap-autocomplete>
                          </label>
                          <!-- <div
                            class="d-flex align-center mb-3">
                            <v-btn
                              v-for="(item, index) in menu"
                              :key="index"

                              @click="selected.menu = item; initMap();"

                              :color="selected.menu === item ? set_color : ''"
                              :class="selected.menu === item ? 'white--text' : ''"
                              :style="selected.menu === item ? 'font-weight: 600;' : ''"

                              small
                              rounded
                              elevation="0"
                              class="text-capitalize mr-4">
                              {{ item }}
                            </v-btn>
                          </div> -->

                          <div v-if="selected.menu === 'Koordinat'">
                            <gmap-map
                              :center="center"
                              :zoom="12"
                              :options="{
                                zoomControl: true,
                                mapTypeControl: false,
                                scaleControl: false,
                                streetViewControl: false,
                                rotateControl: false,
                                fullscreenControl: true,
                                disableDefaultUi: false
                              }"
                              :clickable="true"
                              @click="updatePlace"
                              style="width: 100%; height: 400px;">

                              <gmap-marker
                                :position="center"
                                :draggable="true"
                                @drag="updatePlace"
                                @click="center = center">
                              </gmap-marker>
                            </gmap-map>
                          </div>

                          <!-- <div v-if="selected.menu === 'Polygon'">
                            <v-card
                              flat
                              min-height="500px"
                              color="transparent"
                              style="border-radius: 10px;">
                              <div 
                                id="map" 
                                style="width: 100%; height: 500px;">
                              </div>
                            </v-card>
                          </div> -->
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="pt-6">
                          <ValidationProvider 
                            name="Latitude" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->

                              Latitude
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              dense
                              readonly

                              onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                              type="number"
                              min="0"

                              :color="set_color"
                              placeholder="Contoh. -6.1805"

                              v-model="form.latitude"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="pt-6">
                          <ValidationProvider 
                            name="Longitude" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div class="fs-15 label-input">
                              <!-- <span class="red--text">*</span> -->

                              Longitude
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              dense
                              readonly

                              onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                              type="number"
                              min="0"

                              :color="set_color"
                              placeholder="Contoh. 106.8284"


                              v-model="form.longitude"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <!-- <v-row>
                        <v-col
                          cols="12"
                          md="6">
                          <ValidationProvider 
                            name="Jenis Kelamin" 
                            rules="required"
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>
                              
                              Jenis Kelamin
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"

                              outlined
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Laki-Laki"

                              hide-details

                              :items="['Laki-Laki', 'Perempuan']"
                              :item-color="set_color"

                              v-model="form.gender"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.gender !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row> -->

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                color="#240087"
                class="body-2 white--text text-capitalize border-radius">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                to="/master-pembelian/supplier"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        form: {
          id: '',
          name: '',
          email: '',
          mobilephone: '',
          address: '',
          latitude: '',
          longitude: '',
          pic_name: '',
          pic_email: '',
          pic_mobilephone: '',
        },
        menu: ['Koordinat', 'Polygon'],

        selected: {
          row: [],
          freeze: [],
          delete: [],

          menu: 'Koordinat'
        },

        map: null,

        center: {
          lat: -6.1805, 
          lng: 106.8284
        },
        upload: {
          image: null
        },

        process: {
          form: false,

          image: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
      this.form.outlet_id = this.user.cat_title === 'Owner' ? this.outlet.outlet_id : ''
    },
    methods: {
      async fetchDetail () {
          let params = {
            id: this.$route.params.id
          }
  
          await get(`pos/pembelian/supplier/detail`, { params })
          .then(response => {
            let res = response.data
  
            if (res.status === 200) {
              this.detail = res.results.data
              this.form.id = this.detail.id
              this.form.name = this.detail.name
              this.form.email = this.detail.email
              this.form.mobilephone = this.detail.mobilephone
              this.form.address = this.detail.address
              this.form.latitude = this.detail.latitude
              this.form.longitude = this.detail.longitude
              this.form.pic_name = this.detail.pic_name
              this.form.pic_email = this.detail.pic_email
              this.form.pic_mobilephone = this.detail.pic_mobilephone
              this.center = {
                lat: parseFloat(this.detail.latitude),
                lng: parseFloat(this.detail.longitude)
              }
            }
          })
        },

      setPlace(place) {
        this.place = place
        this.center = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        
        }
        this.initMap()
        this.form.latitude = this.place.geometry.location.lat()
        this.form.longitude = this.place.geometry.location.lng()
      },

      updatePlace (location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      // INIT MAP
      initMap () {
        let self = this

        this.$gmapApiPromiseLazy().then(() => {
          self.map = new google.maps.Map(document.getElementById('map'), {
            center: { 
              lat: -6.1805, 
              lng: 106.8284
            },
            zoom: 18,
            noClear: true,
            mapTypeId: 'hybrid', //satellite
            navigationControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            tilt: 0
          })

          self.map.data.addListener('addfeature', self.featureAdded)

          const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_LEFT,
              drawingModes: ['polygon']
            },
            polygonOptions: {
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            }
          })

          drawingManager.setMap(self.map)

          drawingManager.addListener('polygoncomplete', (polygon) => {
            if (polygon.getPath().getLength() < 3) {
              console.log('Polygons must have 3 or more points.')

              polygon.getPath().clear()
            } else {
              // self.form.latlong_json_arr = []

              this.set_polygon_complete = true

              self.addFeature('Polygon', polygon.getPath())

              polygon.setMap(null)
            }
          })

          // #JIKA SINGLE POLYGON
          // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

          // ======================== SPLIT ======================== \\

          // #JIKA MULTI POLYGON
          if (this.form.latlong_json_arr.length > 0) {
            this.form.latlong_json_arr.forEach(obj => {
              self.addFeature('Polygon', obj.latlng)
            })
          }
        })
      },

      featureAdded (e) {
        switch (e.feature.getGeometry().getType()) {
          case 'Polygon':
            addFeature('Polygon', e.feature.getGeometry().getAt(0).getArray())

            break
        }

        self.map.data.remove(e.feature)
      },

      addFeature (type, path) {
        let self = this

        let index_latlng = ''

        switch (type) {
          case 'Polygon':
            let polygon = new google.maps.Polygon({
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            })

            polygon.setPath(path)

            polygon.addListener('click', (e) => {
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.getPath().addListener('insert_at', (e) => {
              // console.log(e)
            })

            polygon.getPath().addListener('set_at', (e, obj) => {
              // self.form.latlong_json_arr[e].lat = obj.lat()
              // self.form.latlong_json_arr[e].lng = obj.lng()

              let polypath = polygon.getPath()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []
              
              for (var i = 0; i < polypath.length; i++) {
                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.getPath().addListener('remove_at', (e) => {
              // console.log(e)
            })

            polygon.addListener('dragstart', (e) => {
              // #JIKA SINGLE POLYGON
              // Konten ketika single polygon

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              let polypath = polygon.getPath()


              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === polypath.getAt(0).lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.addListener('dragend', (e) => {
              let polypath = polygon.getPath()
              let bounds = new google.maps.LatLngBounds()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   bounds.extend(polypath.getAt(i))

              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // let center = bounds.getCenter()
              // stringlocation = JSON.stringify(self.form.latlong_json_arr)
              // stringcenter = JSON.stringify(center)
              // console.log(stringcenter + stringlocation)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []

              for (var i = 0; i < polypath.length; i++) {
                bounds.extend(polypath.getAt(i))

                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.addListener('rightclick', (e) => {
              // #JIKA SINGLE POLYGON
              // if (e.vertex == undefined) return

              // if (polygon.getPath().getLength() === 3) {
              //   polygon.setMap(null)
                
              //   self.form.latlong_json_arr = []
              // } else {
              //   console.log(index_latlng)
              //   polygon.getPath().removeAt(e.vertex)
              //   self.form.latlong_json_arr.splice(e.vertex, 1)
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })

              if (e.vertex == undefined) return

              if (polygon.getPath().getLength() === 3) {
                polygon.setMap(null)
                
                // self.form.latlong_json_arr = []

                self.form.latlong_json_arr.splice(index_latlng, 1)
              } else {
                polygon.getPath().removeAt(e.vertex)
                self.form.latlong_json_arr[index_latlng].latlng.splice(e.vertex, 1)
              }
            })

            let data_polygon = polygon.getPath()

            let before_insert = []

            for (let i = 0; i < data_polygon.getLength(); i++) {
              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr.push({
              //   lat: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[0]),
              //   lng: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[1])
              // })

              // const lats = self.form.latlong_json_arr.map(o => o.lat)
              // self.form.latlong_json_arr = self.form.latlong_json_arr.filter(({lat}, index) => !lats.includes(lat, index + 1))

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              before_insert.push({
                lat: parseFloat(data_polygon.getAt(i).lat()),
                lng: parseFloat(data_polygon.getAt(i).lng())
              })

              const lats = before_insert.map(o => o.lat)
              before_insert = before_insert.filter(({lat}, index) => !lats.includes(lat, index + 1))
            }

            if (before_insert.length > 2 && self.set_polygon_complete) {
              self.form.latlong_json_arr.push({
                index: self.form.latlong_json_arr.length,
                lat: before_insert[0].lat,
                lng: before_insert[0].lng,
                latlng: before_insert
              })

              self.set_polygon_complete = false
            }

            console.log(self.form.latlong_json_arr)

            polygon.setMap(self.map)

            break
        }
      },

      addLatlng () {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.push({
        //   lat: null,
        //   lng: null
        // })

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr.push({
          index: this.form.latlong_json_arr.length,
          latlng: [
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            }
          ]
        })
      },

      removeLatlng (index) {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.splice(index, 1)

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr[index].latlng.splice(index_sub, 1)

        if (this.form.latlong_json_arr[index].latlng.length < 3) {
          this.form.latlong_json_arr.splice(index, 1)
        }

        this.initLatlng()
      },

      initLatlng () {
        let self = this

        if (this.form.latlong_json_arr.length > 2) {
          if (this.form.latlong_json_arr[2].lat !== '' && this.form.latlong_json_arr[2].lat !== null && this.form.latlong_json_arr[2].lng !== '' && this.form.latlong_json_arr[2].lng !== null) {
            this.$gmapApiPromiseLazy().then(() => {
              self.map = new google.maps.Map(document.getElementById('map'), {
                center: { 
                  lat: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lat : -7.7126396311,
                  lng: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lng : 110.5909243135
                },
                zoom: 18,
                noClear: true,
                mapTypeId: 'hybrid', //satellite
                navigationControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                tilt: 0
              })
    
              self.map.data.addListener('addfeature', self.featureAdded)
    
              const drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: this.form.latlong_json_arr.length < 1 ? google.maps.drawing.OverlayType.POLYGON : null,
                drawingControl: true,
                drawingControlOptions: {
                  position: google.maps.ControlPosition.TOP_LEFT,
                  drawingModes: ['polygon']
                },
                polygonOptions: {
                  fillColor: '#FF0000',
                  fillOpacity: 0.35,
                  strokeColor: '#FF0000',
                  strokeWeight: 2,
                  strokeOpacity: 1,
                  draggable: true,
                  editable: true,
                  clickable: true,
                  zIndex: 1
                }
              })
    
              drawingManager.setMap(self.map)
    
              drawingManager.addListener('polygoncomplete', (polygon) => {
                if (polygon.getPath().getLength() < 3) {
                  console.log('Polygons must have 3 or more points.')
                  polygon.getPath().clear()
                } else {
                  self.addFeature('Polygon', polygon.getPath())
                  polygon.setMap(null)
                }
              })
    
              // #JIKA SINGLE POLYGON
              // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              if (this.form.latlong_json_arr.length > 0) {
                this.form.latlong_json_arr.forEach(obj => {
                  self.addFeature('Polygon', obj.latlng)
                })
              }
            })
          }
        } else {
          this.initMap()
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`pos/pembelian/supplier/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: `/master-pembelian/supplier/detail/${this.form.id}` })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style>
 .pac-target-input {
  width: 100% !important;
  border: 1px solid #d1d1d1 !important;
  padding: 10px !important;
  border-radius: 10px !important;
 }
</style>